
import { defineComponent } from "vue";

export default defineComponent({
  name: "credit-bilance",
  props: {
    cardClasses: String,
  },
  components: {},
});
